export default __webpack_public_path__ + "static/media/kids.255daa55.jpg";